<template>
  <div class="header-container">
    <div class="logo">
      <img src="@/assets/home/logo.png" />
      <div class="phone-number">
        <span class="des">考务热线：</span>
        <span class="number">400-018-5055</span>
      </div>
    </div>
    <div class="tab">
      <ul class="clearfix">
        <li
          :class="{ actived: actived(item) }"
          @click="clickTab(item)"
          v-for="item in tabs"
          :key="item.path"
        >
          {{ item.title }}
          <img
            src="@/assets/home/line.png"
            v-show="actived(item)"
          />
        </li>
        <li>
          <a
            target="_blank"
            href="https://exam.cnset.com.cn/login"
          >测评中心</a>
        </li>
        <li style="margin-left: 40px; width: 100px">
          <a
            target="_blank"
            href="#"
            onclick="return false"
            :class="[isShow ? 'signtextOn' : 'signtextOff']"
            @click="changeShow()"
          >考生报名
            <img
              :class="[isShow ? 'arrowUp' : 'arrowDown']"
              style="position: relative; width: 16px; top: 0px; left: 0px"
              src="@/assets/home/dropdown.png"
              ref="arrowImg"
            />
          </a>
          <transition name="fade">
            <div
              v-show="isShow"
              class="tip"
              ref="tip"
            >
              <img
                style="left: -25px"
                src="@/assets/home/wxpub.png"
              />
            </div>
          </transition>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShow: true,
      tabs: [
        { path: "/home", selected: true, title: "首页" },
        { path: "/reviewcriterion", selected: false, title: "测评标准" },
        { path: "/reviewtechnology", selected: false, title: "测评技术" },
        { path: "/aboutexamination", selected: false, title: "组织机构" },
        // { path: "/news", selected: false, title: "最新动态" }
        // { path: "报名测评", selected: false, title: "官方合作" },
        // { path: "报名考", selected: false, title: "报名测评" }
      ],
    };
  },
  computed: {
    actived() {
      return (item) => {
        return this.$route.path.indexOf(item.path) != -1;
        // return item.path == this.$route.path;
      };
    },
  },
  methods: {
    clickTab(item) {
      this.tabs.forEach((tab) => {
        tab.selected = false;
      });
      item.selected = true;
      this.$router.push({ path: item.path });
    },
    changeShow() {
      this.isShow = !this.isShow;
    },
  },
};
</script>
<style lang="less" scoped>
.header-container {
  background-color: white;
  height: 95px;
  width: 1200px;
  margin: 17px auto 0 auto;
  .logo {
    display: inline-block;
    padding: 10px 0;
    position: relative;
    .phone-number {
      display: inline-block;
      position: absolute;
      width: 250px;
      left: 145px;
      top: 13px;
      font-size: 18px;
      font-style: italic;
      .number {
        color: #ff4b00;
        font-weight: bolder;
      }
    }
  }
  .tab {
    display: inline-block;
    margin-left: 120px;
    margin-bottom: -5px;
    ul {
      li {
        margin: 0 20px;
        cursor: pointer;
        float: left;
        font-size: 16px;
        color: #333333;
        position: relative;
        display: inline-block;
        width: 72px;
        text-align: center;
        img {
          position: absolute;
          left: 0;
          bottom: -10px;
          right: 0;
        }
        a {
          color: #333333;
          // &.actived,
          // &:hover {
          //   color: #344f97;
          // }
        }
        .tip {
          position: absolute;
          left: -13px;
          top: 190px;
          img {
            z-index: 999;
          }
        }
        &.actived,
        &:hover {
          color: #344f97;
          font-weight: bolder;
        }
        .signtextOn {
          color: #07c160;
          font-weight: bold;
        }
        .signtextOff {
          color: #333333;
          font-weight: normal;
        }
        .arrowUp {
          transform: rotate(-180deg);
          transition: all 0.2s;
        }
        .arrowDown {
          transition: all 0.2s;
          -webkit-filter: grayscale(100%);
          -moz-filter: grayscale(100%);
          -ms-filter: grayscale(100%);
          -o-filter: grayscale(100%);
          filter: grayscale(100%);
          filter: gray;
        }
        // .fade-enter-active,
        // .fade-leave-active {
        //   transition: all .5s;
        //   height: 181px !important;
        // }
        // .fade-enter,
        // .fade-leave-to {
        //   height: 0px !important;
        // }
      }
    }
  }
}
</style>
